import MolecularFormulaManipulator from "../../util/MolecularFormulaManipulator.js";

export default class StructureCmp extends HTMLElement {
	constructor(structureSvg, molFormula, mass) {
		super();
		this._structureSvg = structureSvg;
		this._molFormula = molFormula;
		this._mass = mass;
	}

	connectedCallback() {
		const template = document.createElement('template');
		template.innerHTML = this._template(this._structureSvg, this._molFormula, this._mass);
		this.attachShadow({mode: 'open'}).appendChild(template.content.cloneNode(true))
	}

	_template(structureSvg, molFormula, mass) {
		return `
              <style> @import "/ui/js/components/structure/style.css"; </style>
              ${structureSvg}
              <div class="structure-description">
                <span class="mf">${MolecularFormulaManipulator.subNumbers(molFormula)}</span>
                <span class="emw-label">EMW: </span><span class="emw">${mass.toFixed(4)}</span>
              </div>`;
	}
}